<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div class="index">
                <index-one></index-one>
                <index-two></index-two>
                <div style="width:100%" class="transfer-box">
                    <div class="from" style="width:200px;height:400px;padding:10px;overflow:auto;float:left;border:1px solid #ddd">
                        <ul>
                            <li v-for="(list,index) in arr_1">
                                <input type="checkbox" :value="list.id" :id="list.id" v-model="check_arr1">
                                <label :for="list.id"><span>{{list.name}}</span></label>
                            </li>
                        </ul>
                    </div>
                    <div class="go" style="width:50px;height:400px;float:left;text-align:center;line-height:50px;">
                        <div><i class="el-icon-d-arrow-right fs-24" style="cursor: pointer;" @click="go(arr_1,arr_2,check_arr1)"></i></div>
                        <div><i class="el-icon-d-arrow-left fs-24" style="cursor: pointer;" @click="go(arr_2,arr_1,check_arr2)"></i></div>
                    </div>
                    <div class="to" style="width:200px;height:400px;padding:10px;overflow:auto;float:left;border:1px solid #ddd">
                        <ul>
                            <li v-for="(list,index) in arr_2">
                                <input type="checkbox" :value="list.id" :id="list.id" v-model="check_arr2">
                                <label :for="list.id"><span>{{list.name}}</span></label>
                            </li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div>读取XLS文件</div>
                    <input type="file" @change="readXLSXfun">
                    <ul>
                        <li v-for="list in upload_arr">
                            <div v-for="(item, key) in list">
                                {{ key }}: {{ item }}
                            </div>
                        </li>
                    </ul>
                    <div>读取TXT文件</div>
                    <input type="file" @change="readTXTfun">
                    <div>{{ file_txt }}</div>
                    <div>jquery 加载完自动读取txt文件</div>
                    <el-button id="btn1">btn1</el-button>
                    <div id="txt_file"></div>

                    <div>
                        <pre>
axios用法： 
    get: 
        axios.get(url) 
            .than(res => { 
                console.log(res.data) 
            }) 
            .catch(error => { 
                console.log(error) 
            }) 
    post: 
        axios.post('/user', { 
                firstName: 'Fred', 
                lastName: 'Flintstone' 
            }) 
            .than(res => { 
                console.log(res.data) 
            }) 
            .catch(error => { 
                console.log(error) 
            })
                        </pre>
                        <div>
                            axios.request（config）<br>
                            axios.get（url [，config]）<br>
                            axios.delete（url [，config]）<br>
                            axios.head（url [，config]）<br>
                            axios.post（url [，data [，config]]）<br>
                            axios.put（url [，data [，config]]）<br>
                            axios.patch（url [，data [，config]]）
                        </div>
                        <div v-for="(value, key, index) in json">
                            {{ index }}. {{ key }} - {{ value }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    import indexOne from './index-one.vue'
    import indexTwo from './index-two.vue'

    import ReadFile from '../common-vue/readFile.vue'
    export default {
        mixins:[ReadFile],
        data(){
            return {
                check_arr1:[],
                check_arr2:[],
                arr_1:[
                    {
                        id:1,
                        name:1
                    },
                    {
                        id:2,
                        name:2
                    },
                    {
                        id:3,
                        name:3
                    },
                    {
                        id:4,
                        name:4
                    },
                    {
                        id:5,
                        name:5
                    },
                ],
                arr_2:[
                    {
                        id:11,
                        name:11
                    },
                    {
                        id:22,
                        name:22
                    },
                    {
                        id:33,
                        name:33
                    },
                    {
                        id:44,
                        name:44
                    },
                    {
                        id:55,
                        name:55
                    },
                ],
                json:{}
            }
        },
        created(){
            this.$parent.routerLoading();
        },
        components:{
            indexOne,
            indexTwo
        },
        methods:{
            go(arr1,arr2,check_arr){
                for(let i = arr1.length - 1; i >= 0; i--){
                    if(check_arr.indexOf(arr1[i].id) >= 0){
                        arr2.push(arr1[i]);
                        arr1.splice(i,1);
                    }
                }
                this.check_arr1 = [];
                this.check_arr2 = [];
            },
            readXLSXfun($event){
                let file = $event.target.files[0];
                this.readerXLSX(file)
            },
            readTXTfun($event){
                let file = $event.target.files[0];
                this.readerTXT(file)
            }
        },
        mounted(){
            this.$nextTick(() => {
                this.$ajax.get('https://jsonplaceholder.typicode.com/todos/1').then((res) => {
                  var result = res.data
                  for(let i in result){
                    this.json[i] = result[i]
                  }
                })
            })
        }
    }
</script>
<style scoped>
    .transfer-box::after{
        content: '';
        width: 0;
        height: 0;
        display: block;
        clear: both;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/transfer-value/index.vue